<template>
<div>


    <!-- Information du profile -->
    <div class="row">
      <h3 class="font-w300 push-10">{{ labelTitle[actualLanguage] }}</h3>

      <div v-if="displayTab" class="col-xs-12">
          <div class="block">
              <ul class="nav nav-tabs nav-tabs-alt nav-justified" data-toggle="tabs">

                <li :class="{'active': tabMenuSelector[0]==true}"  @click="toggleTabMenuSelector(0)">
                    <a ><i class="fa fa-dashboard"></i> {{tabLabelMainService[actualLanguage] }}</a>
                </li>

                <li :class="{'active': tabMenuSelector[1]==true}"  @click="toggleTabMenuSelector(1)">
                    <a ><i class="fa fa-building"></i> {{tabLabelUnits[actualLanguage] }}</a>
                </li>

                <li :class="{'active': tabMenuSelector[2]==true}"  @click="toggleTabMenuSelector(2)">
                    <a ><i class="fa fa-user"></i> {{tabLabelOccupants[actualLanguage] }}</a>
                </li>

                <li :class="{'active': tabMenuSelector[3]==true}"  @click="toggleTabMenuSelector(3)">
                    <a ><i class="fa fa-gear"></i> {{tabLabelComplement[actualLanguage] }}</a>
                </li>

              </ul>

              <div class="block-content tab-content">

                <div :class="{'tab-pane': true, 'active': tabMenuSelector[0]==true}" >

                  <div class="col-xs-12">

                    <spinner  v-if="mainServiceListIsLoading"></spinner>
                    <div v-else>
                        <div v-for="(mainService,index) in MainServiceList">
                          <div class="row">
                            <main-service-display :mainService="mainService" ></main-service-display>

                            <div class="col-sm-12">
                              <button  type="button" @click="deleteMainService(index)" class="btn btn-xs align-right" name="buttonAddPlanItem">
                              <spinner size="small" v-if="serviceIsDeleting"></spinner>
                              <span v-else><i class="fa fa-trash-o fa-1x push-5-r "></i>{{ labelButtonDeleteService[actualLanguage] }}</span></button>
                            </div> 
                          </div> 
                        </div>
                    </div>

                    <p><button @click="addMainService" type="button" class="btn  btn-success align-left" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddMainService[actualLanguage] }}</button></p>

                  </div>


                </div>


                <div :class="{'tab-pane': true, 'active': tabMenuSelector[1]==true}" >


                  <div class="col-xs-12">

                    <spinner  v-if="unitListIsLoading"></spinner>
                    <div v-else>
                        <div class="row">
                          <unit-display-stats :unitList="UnitList" ></unit-display-stats>
                        </div> 

                        <div v-for="(unit,index) in UnitList">
                          <div class="row">
                            <unit-display :unit="unit" ></unit-display>

                            <div class="col-sm-12">
                              <button  type="button" @click="deleteUnit(index)" class="btn btn-xs align-right" name="buttonAddPlanItem">
                              <spinner size="small" v-if="unitIsDeleting"></spinner>
                              <span v-else><i class="fa fa-trash-o fa-1x push-5-r "></i>{{ labelButtonDeleteService[actualLanguage] }}</span></button>
                            </div> 
                          </div> 
                        </div>
                    </div>

                    <p><button @click="addUnit" type="button" class="btn  btn-success align-left" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddUnit[actualLanguage] }}</button></p>

                  </div>


                </div>

                <div :class="{'tab-pane': true, 'active': tabMenuSelector[2]==true}" >
                    <spinner  v-if="occupantListIsLoading"></spinner>
                    <div v-else>
                        <div v-for="(occupant,index) in occupantsList">
                          <div class="row">
                            <occupant-display :occupant="occupant" ></occupant-display>

                            <div class="col-sm-12">
                              <button  type="button" @click="deleteOccupant(index)" class="btn btn-xs align-right" name="buttonAddPlanItem">
                              <spinner size="small" v-if="occupantIsDeleting"></spinner>
                              <span v-else><i class="fa fa-trash-o fa-1x push-5-r "></i>{{ labelButtonDeleteService[actualLanguage] }}</span></button>
                            </div> 
                          </div> 
                        </div>
                    </div>

                    <p><button @click="addOccupant" type="button" class="btn  btn-success align-left" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddOccupant[actualLanguage] }}</button></p>
                </div>

                <div :class="{'tab-pane': true, 'active': tabMenuSelector[3]==true}" >
                    <comp-unit-tags-display></comp-unit-tags-display>
                    <comp-compare-level-message-display></comp-compare-level-message-display>

                </div>

              </div>
              
          </div>
      </div>


    </div>

</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import MainServiceDisplay from './MainServiceDisplay'
import UnitDisplay from './UnitDisplay'
import UnitDisplayStats from './UnitDisplayStats'
import CompUnitTagsDisplay from './CompUnitTagsDisplay'
import CompCompareLevelMessageDisplay from './CompCompareLevelMessageDisplay'
import OccupantDisplay from './OccupantDisplay'

export default {
  name: 'GroupIndex',
  data() {
    return {
      flagDisplayBanner : 0,
      profileIsSaving : false,
      actualLanguage : "FR",
      mainServiceListIsLoading : true,
      
      serviceIsDeleting:false,
      labelTitle: {FR: "Répartiteur de coût de service", EN: 'Service cost splitter'},
      labelButtonAddMainService: {FR: "Ajouter un service principal", EN: 'Add main service'},
      labelButtonDeleteService: {FR: "Supprimer", EN: 'Delete'},
      messagePromptMainServiceReferenceName:{FR: "Nom de référence du service principal", EN: 'Main service reference name'},
      messagePromptMainServiceReferenceNameTextBox:{FR: "Nom de référence", EN: 'Reference name'},

      messageRemoveService:{FR: "ATTENTION : La supression d'un service principal peut affecter les configurations de votre système de répartition de coût, assurez vous que les unités lié au service principal et sous services rattachés n'y soient plus liés.",
                              EN: 'WARNING : The deletion of a main service can affect the configurations of your cost splitting system, make sure that the units linked to the main service and under attached services are no longer linked to it.'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du service : ", EN: 'Confirm service deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},

      MainServiceList: [],


      tabLabelMainService : {FR: "Services", EN: 'Services'},

      unitIsDeleting : false,
      tabLabelUnits : {FR: "Unités", EN: 'Unit'},
      messageRemoveUnit:{FR: "ATTENTION : La supression d'une unité peut affecter les configurations de votre système de répartition de coût, cette action n'est pas récupérable suite a son exécution.",
                              EN: 'WARNING: Deleting a unit can affect the configurations of your cost distribution system, this action is not recoverable after its execution.'},
      messageRemoveUnitConfirmA:{FR: "Confirmer la supression de l'unité : ", EN: 'Confirm unit deletion : '},
      messageRemoveUnitConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},


      tabLabelOccupants: {FR: "Occupants", EN: 'Occupants'},
      tabLabelComplement: {FR: "Compléments", EN: 'Complement'},
      tabMenuSelector : [],
      test : 0,
      displayTab : false,

      unitListIsLoading : true,
      UnitList: [],
      labelButtonAddUnit: {FR: "Ajouter une unité", EN: 'Add unit'},
      messagePromptUnitReferenceName:{FR: "Nom de référence de l'unité", EN: 'Unit reference name'},

      occupantListIsLoading : true,
      occupantIsDeleting : false,
      occupantsList: [],
      labelButtonAddOccupant: {FR: "Ajouter un occupant", EN: 'Add occupant'},
      messagePromptOccupantFirstName:{FR: "Prénom de l'occupant principal à ajouter", EN: 'Firstname of the occupant to add'},
      messagePromptOccupantFirstNameTextBox:{FR: "Prénom", EN: 'Firstname'},
      messagePromptOccupantLastName:{FR: "Nom de l'occupant principal à ajouter", EN: 'Lastname of the occupant to add'},
      messagePromptOccupantLastNameTextBox:{FR: "Nom", EN: 'Lastname'},
      messageRemoveOccupantConfirmA:{FR: "Confirmer la supression de l'occupant: ", EN: 'Confirm occupant deletion : '},
      messageRemoveOccupantConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},




    }
  },
  components: {
    Spinner,
    MainServiceDisplay,
    UnitDisplay,
    UnitDisplayStats,
    CompUnitTagsDisplay,
    CompCompareLevelMessageDisplay,
    OccupantDisplay
  },
  computed: {
    ...mapState('sessionStore', ['actualBundle','parentContainer']),
  },

  watch: {
    actualBundle(){
        this.readMainServiceList()
    },
  },  

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
    },

    toggleTabMenuSelector(index){
        this.displayTab = false
        for(var n=0;n<this.tabMenuSelector.length;n++){this.tabMenuSelector[n]=false}
        this.tabMenuSelector[index]=true
        localStorage.actualCostSplitTab = index

        if(this.tabMenuSelector[0]){this.readMainServiceList()}
        if(this.tabMenuSelector[1]){this.readUnitList()}
        if(this.tabMenuSelector[2]){this.readOccupantList()}
        
        //Comprend pas mais besoin de cette ligne pour que ca fonctionne !!
        this.test = index
        this.displayTab = true
    },


    readMainServiceList(){
        var requestData = {'postAction':'GetBundleMainServices',
                          'bundleId':this.actualBundle.bundle_id}
        this.mainServiceListIsLoading=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.mainServiceListIsLoading=false
                this.MainServiceList = response.data.MainServiceList
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.mainServiceListIsLoading=false
                  }
            })
    },


    addMainService(){
        var mainServiceReferenceName = prompt(this.messagePromptMainServiceReferenceName[this.actualLanguage], this.messagePromptMainServiceReferenceNameTextBox[this.actualLanguage]);

        if(mainServiceReferenceName != null){
          var requestData = {'postAction':'AddMainServiceToBundle',
                            'bundleId':this.actualBundle.bundle_id,
                            'parentContainer':this.parentContainer,
                            'referenceName':mainServiceReferenceName}
          this.$store.dispatch('sessionStore/postBundle', requestData)
              .then((response) => {
                //console.log(this.response)
              if(response.data.Code=='OK'){
                  this.readMainServiceList()
                  }
                  else{
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    }
              })
        }
    },


    deleteMainService(index){
          window.alert(this.messageRemoveService[this.actualLanguage])
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.MainServiceList[index].reference_name, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.deviceIsDeleting = true
              var requestData = { 'postAction':'DeleteMainService',
                                  'bundleId': this.actualBundle.bundle_id,
                                  'parentContainer':this.parentContainer,
                                  'mainServiceData':this.MainServiceList[index]
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.deviceIsDeleting = false
                      this.readMainServiceList()
                      }
                      else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                  })       
          }

    },




    readUnitList(){
        var requestData = {'postAction':'GetBundleUnits',
                          'bundleId':this.actualBundle.bundle_id}
        this.unitListIsLoading=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.unitListIsLoading=false
                this.UnitList = response.data.UnitList
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.unitListIsLoading=false
                  }
            })
    },

    addUnit(){
        var unitReferenceName = prompt(this.messagePromptUnitReferenceName[this.actualLanguage], this.messagePromptMainServiceReferenceNameTextBox[this.actualLanguage]);

        if(unitReferenceName != null){
          var requestData = {'postAction':'AddUnitToBundle',
                            'bundleId':this.actualBundle.bundle_id,
                            'parentContainer':this.parentContainer,
                            'referenceName':unitReferenceName}
          this.$store.dispatch('sessionStore/postBundle', requestData)
              .then((response) => {
                //console.log(this.response)
              if(response.data.Code=='OK'){
                  this.readUnitList()
                  }
                  else{
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    }
              })
        }
    },


    deleteUnit(index){
          window.alert(this.messageRemoveUnit[this.actualLanguage])
          var confirmation = prompt(this.messageRemoveUnitConfirmA[this.actualLanguage]+this.UnitList[index].reference_name, this.messageRemoveUnitConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.unitIsDeleting = true
              var requestData = { 'postAction':'DeleteUnit',
                                  'bundleId': this.actualBundle.bundle_id,
                                  'parentContainer':this.parentContainer,
                                  'unitData':this.UnitList[index]
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.unitIsDeleting = false
                      this.readUnitList()
                      }
                      else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                  })       
          }

    },



    addOccupant(){
        var occupantFirstName = prompt(this.messagePromptOccupantFirstName[this.actualLanguage], this.messagePromptOccupantFirstNameTextBox[this.actualLanguage]);
        var occupantLastName = prompt(this.messagePromptOccupantLastName[this.actualLanguage], this.messagePromptOccupantLastNameTextBox[this.actualLanguage]);

        if(occupantFirstName != null && occupantLastName != null ){
          var requestData = {'postAction':'AddOccupant',
                            'bundleId':this.actualBundle.bundle_id,
                            'parentContainer':this.parentContainer,
                            'firstname':occupantFirstName,
                            'lastname':occupantLastName}
          this.$store.dispatch('sessionStore/postBundle', requestData)
              .then((response) => {
                //console.log(this.response)
              if(response.data.Code=='OK'){
                  this.occupantsList = response.data.OccupantList
                  }
                  else{
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    }
              })
        }
    },

    deleteOccupant(index){
          var confirmation = prompt(this.messageRemoveOccupantConfirmA[this.actualLanguage]+this.occupantsList[index].completeName, this.messageRemoveOccupantConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.occupantIsDeleting = true
              var requestData = { 'postAction':'DeleteOccupant',
                                  'bundleId': this.actualBundle.bundle_id,
                                  'parentContainer':this.parentContainer,
                                  'occupantData':this.occupantsList[index]
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.occupantsList = response.data.OccupantList
                      this.occupantIsDeleting = false
                      }
                      else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                  })       
          }

    },

    readOccupantList(){
        var requestData = {'postAction':'GetOccupantList',
                          'bundleId':this.actualBundle.bundle_id}
        this.occupantListIsLoading=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.occupantsList = response.data.OccupantList
                this.occupantListIsLoading=false
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.unitListIsLoading=false
                  }
            })
    },



    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    //console.log(this.actualBundle)


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.tabMenuSelector= [true, false, false, false, false, false]

    if(localStorage.actualCostSplitTab){
      this.toggleTabMenuSelector(localStorage.actualCostSplitTab)
    }else{
      this.toggleTabMenuSelector(0)
    }
    this.displayTab = true

    this.readMainServiceList()
    
  }
}
</script>





// WEBPACK FOOTER //
// Index.vue?c05a498a